$(() => {
    //set id editable-table in form around table
    //set class table-edit-btn on the table row btn that should trigger edit
    //set class contenteditable on edit input area in td
    //set data-contenteditableformcancel in button that should cancel and hide contenteditable
    //all input name attributes are posted to controller as json

    //selectors
    const tableeditbtns = document.querySelectorAll('.table-edit-btn');
    const contentEditableFormCancels = document.querySelectorAll(
        "button[data-contenteditableformcancel='true']"
    );
    const contentEditableForm = document.querySelector('#editable-table');

    //functions
    tableeditbtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const editableAreas = e.target
                .closest('.mypages--plugin-grid')
                .querySelectorAll('.contenteditable');

            editableAreas.forEach((area) => {
                area.classList.toggle('d-none');
            });
        });
    });
    const submit = ($form, json, tableRow) => {
        const currentUrl = $form.getAttribute('action');

        fetch(currentUrl, {
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            method: 'POST',
            cache: 'no-store',
            body: JSON.stringify(json)
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.Payload != null) {
                    for (const key in result.Payload) {
                        if (result.Payload[key] != null) {
                            const input = tableRow.querySelector('.contenteditabletext-' + key);
                            if (input != null) {
                                input.textContent = result.Payload[key];
                                input.classList.add('text-success', 'font-weight-bold');
                                setTimeout(() => {
                                    input.classList.remove('text-success', 'font-weight-bold');
                                }, 3000);
                            }
                        }
                    }
                    tableRow
                        .querySelectorAll('.contenteditable')
                        .forEach((el) => el.classList.toggle('d-none'));
                }
            })
            .catch((error) => {
                alert('Error:', error);
            });
    };
    const inputToJson = (tableRow) => {
        const inputs = tableRow.querySelectorAll('.contenteditable input');
        const data = {};
        inputs.forEach((input) => {
            const name = input.getAttribute('name');
            const value = input.value;
            data[name] = value;
        });
        return data;
    };
    if (contentEditableForm != null) {
        contentEditableForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const btnClicked = e.submitter;
            const tableRow = btnClicked.closest('.mypages--plugin-grid');
            const json = inputToJson(tableRow);
            submit(e.target, json, tableRow);
        });
    }

    if (contentEditableFormCancels != null) {
        contentEditableFormCancels.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.target
                    .closest('.mypages--plugin-grid')
                    .querySelectorAll('.contenteditable')
                    .forEach((el) => el.classList.toggle('d-none'));
            });
        });
    }
});
